import type { AccordionTokenSections, AccordionDesignTokens } from '@primeuix/themes/types/accordion';

export const root: AccordionTokenSections.Root = {
    transitionDuration: '{extend.transitionDuration.normal}'
};

export const panel: AccordionTokenSections.Panel = {
    borderWidth: '1px',
    borderColor: '{content.border.color}'
};

export const header: AccordionTokenSections.Header = {
    color: '{content.color}',
    hoverColor: '{content.hover.color}',
    activeColor: '{primary.color}',
    activeHoverColor: '{primary.hover.color}',
    padding: '{spacing.medium.3}',
    fontWeight: '600',
    borderRadius: '{borderRadius.md}',
    borderWidth: '1px',
    borderColor: '{content.borderColor}',
    background: '{content.background}',
    hoverBackground: '{content.hover.background}',
    activeBackground: '{content.background}',
    activeHoverBackground: '{content.hoverBackground}',
    focusRing: {
        width: '{focus.ring.width}',
        style: '{focus.ring.style}',
        color: '{focus.ring.color}',
        offset: '{focus.ring.offset}',
        shadow: '{focus.ring.shadow}'
    },
    toggleIcon: {
        color: '{text.muted.color}',
        hoverColor: '{text.color}',
        activeColor: '{primary.color}',
        activeHoverColor: '{primary.hover.color}'
    },
    first: {
        topBorderRadius: '{content.border.radius}',
        borderWidth: '1px'
    },
    last: {
        bottomBorderRadius: '{content.border.radius}',
        activeBottomBorderRadius: '0'
    }
};

export const content: AccordionTokenSections.Content = {
    borderWidth: '0 1px 1px 1px',
    borderColor: '{content.border.color}',
    background: '{content.background}',
    color: '{content.color}',
    padding: '{spacing.medium.3}'
};

export default {
    root,
    panel,
    header,
    content
} satisfies AccordionDesignTokens;
